import React, { useEffect } from "react";
import InfoCard from "./card/InfoCard";
import "./CardSection.css";
import FontSpirulina from "../../font_component/spirulina_font/FontSpirulina";
import { AllAdvantages } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";
import { useDispatch, useSelector } from "react-redux";

const CardSection = () => {
  const dispatch = useDispatch();

  const all_advantages = useSelector((state) => state?.common?.all_advantages);

  useEffect(() => {
    dispatch(AllAdvantages());
  }, [dispatch]);

  const data = [
    {
      title: "Boosts Energy & Immunity",
      description:
        "Spirulina is rich in protein, vitamins, & antioxidants that help improve energy levels & strengthen the immune system.",
    },
    {
      title: "Supports Detox & Digestion",
      description:
        "It helps remove toxins from the body & improves gut health, aiding better digestion & metabolism.",
    },
    {
      title: "Improves Skin & Hair Health",
      description:
        "The antioxidants and nutrients in spirulina promote glowing skin, reduce acne, and strengthen hair from roots.",
    },
    {
      title: "Helps in Weight Management & Heart Health",
      description:
        "Spirulina supports healthy weight loss by controlling appetite and helps reduce bad cholesterol, keeping the heart healthy.",
    },
  ];

  return (
    <section className="card-section">
      <div className="container">
        <div className="card-section-title">
          <h1>
            Advantages Of{" "}
            <FontSpirulina color="#3C9734" weight="normal">
              Spirulina
            </FontSpirulina>{" "}
            In Daily Life
          </h1>
        </div>

        <div className="row justify-content-md-center">
          {all_advantages?.map((item) => {
            return (
              <div className="col-lg-3 col-md-6 col-sm-12">
                <InfoCard title={item?.title} description={item?.discription} />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CardSection;
